import { IServerAdminSettings } from '../../../settings/types/ISite';
import { ISiteAdminSettings, ISiteSubscriptionSettings } from '../../../settings/types/ISiteSettingsForSiteAdmin';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface ICreateSiteParams {
  settings: IServerAdminSettings;
  siteAdminSettings?: ISiteAdminSettings;
  subscriptionSettings?: ISiteSubscriptionSettings;
}

export interface ICreateSiteResult extends IResult {
}

export class CreateSiteRequest extends Request<ICreateSiteParams, ICreateSiteResult> {
  constructor(params: ICreateSiteParams) {
    super('createSite', params);
  }
}
